<template lang="pug">
yz-dialog(v-model="showDialog" persistent scrollable max-width="560")
  yz-card
    yz-dialog-normal-header(:title="dialogTitle" @close="onClose")
    yz-dialog-normal-content.pa-6
      v-form(ref="form" v-model="isFormValid")
        .yz-heading-8.text-neutral-700 Sold by
        .yz-heading-9.text-neutral-700.mb-1.mt-3 Company name
        yz-text-field(v-model="companyName" placeholder="Company name" required)
        yz-card.mt-4(outlined color="neutral-200")
          .pa-4
            div(v-for="(contact, index) in contacts" :key="index" :class="{ 'mt-5': index > 0 }")
              v-row(no-gutters)
                v-col(:cols="hasMultipleContacts ? 5 : 6" :class="{ 'pr-3': true }")
                  .yz-heading-9.text-neutral-700.mb-1 PIC name
                  yz-text-field(v-model="contact.name" placeholder="Name" size="lg" required)
                v-col(:cols="hasMultipleContacts ? 6 : 6" :class="{ 'pr-3': hasMultipleContacts }")
                  .yz-heading-9.text-neutral-700.mb-1 Phone number
                  yz-phone-input(v-model="contact.phone" size="lg" required)
                v-col.d-flex.align-center.justify-center.pt-3(v-if="hasMultipleContacts" cols="1")
                  yz-btn(v-if="index > 0" icon="$yzi-trash-03" outlined icon-color="yz-danger-500" size="lg" background-color="white" @click="onRemoveContact(index)")
            .mt-3
              yz-btn(label="Add more" size="sm" prepend-icon="mdi-plus" @click="onAddContact")
    yz-dialog-normal-actions(:loading="isLoading" @cancel="onClose" @save="onSave")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    editSupplier: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      companyName: '',
      contacts: [{ name: '', phone: '' }],
      isLoading: false,
      isFormValid: false
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    isEditMode() {
      return !!this.editSupplier
    },
    dialogTitle() {
      return this.isEditMode ? 'Edit seller' : 'Add new seller'
    },
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    hasMultipleContacts() {
      return this.contacts.length > 1
    }
  },
  mounted() {
    this.populateForm()
  },
  methods: {
    ...mapActions(['showMessage']),
    populateForm() {
      if (this.editSupplier) {
        this.companyName = this.editSupplier.value || ''
        const extraData = this.editSupplier.extra_data
        const extraDataArray = !extraData ? [] : Array.isArray(extraData) ? extraData : [extraData]
        this.contacts = extraDataArray.map(c => ({
          name: c.name || '',
          phone: c.phone || '',
          default: !!c.default
        }))
        if (this.contacts.length === 0) this.contacts = [{ name: '', phone: '' }]
      } else {
        this.companyName = ''
        this.contacts = [{ name: '', phone: '' }]
      }
    },
    onAddContact() {
      this.contacts.push({ name: '', phone: '' })
    },
    onRemoveContact(index) {
      this.contacts.splice(index, 1)
    },
    async onSave() {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', 'Please fill in all required fields'])
        return
      }
      this.isLoading = true
      try {
        const extraData = this.contacts.map((c, index) => ({
          name: c.name,
          phone: c.phone,
          default: c.default || index === 0
        }))
        if (this.isEditMode) {
          const data = { value: this.companyName, extra_data: extraData }
          const resp = await this.$axios.patch(`/options/${this.editSupplier.id}`, data)
          this.$emit('updated', resp.data)
        } else {
          const data = {
            company: this.company.id,
            field: 'medication.sold_by',
            value: this.companyName,
            enabled: true,
            extra_data: extraData
          }
          const resp = await this.$axios.post('/options', data)
          this.$emit('created', resp.data)
        }
        this.onClose()
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    onClose() {
      this.$emit('update:open', false)
      this.$emit('closed')
    }
  }
}
</script>
